'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z' });

var PowerSettingsNew = function PowerSettingsNew(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

PowerSettingsNew = (0, _pure2.default)(PowerSettingsNew);
PowerSettingsNew.muiName = 'SvgIcon';

exports.default = PowerSettingsNew;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/PowerSettingsNew.js
// module id = 2739
// module chunks = 0